module.exports = "/images/phone-bg@2x.png?1825ad9445bf6666c26e0e3c0cb784ee";